console.log(document.querySelector('.complete-the-look-trigger'));
console.log(document.getElementById('CompleteTheLookModal'));
console.log('DOM ready:', document.readyState);

class CompleteTheLook {

  constructor() {
    console.log('CompleteTheLook constructor');

    this.modal = document.getElementById('CompleteTheLookModal');
  
    if (!this.modal) return;

    this.productId = this.modal.dataset.productId;
    this.mainVariantId = Number(this.modal.dataset.mainVariantId);
    this.sectionId = this.modal.dataset.sectionId;
    this.recommendationsUrl = this.modal.dataset.recommendationsUrl;
    this.discountNote = this.modal.dataset.discountNote
    this.currency = this.modal.dataset.currency;

    this.productsLoaded = false;
    this.productsContainer = this.modal.querySelector(
      '.complete-the-look-modal__products'
    );

    this.trigger = document.querySelector('.complete-the-look-trigger');

    this.closeButton = this.modal.querySelector('.complete-the-look-modal__close');

    this.overlay = this.modal.querySelector('.complete-the-look-modal__overlay');
    this.useColorSwatches = this.modal.dataset.colorSwatches === 'true';

    this.events();
    this.checkComplementaryProducts();

  }

  events() {

    this.trigger?.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      await this.addMainProduct();

      this.open();
    });

    this.closeButton?.addEventListener('click', () => this.close());

    this.overlay?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {

      if (e.key === 'Escape') {

        this.close();

      }

    });

  }

  async open() {

    this.modal.hidden = false;
    document.documentElement.classList.add('complete-the-look-open');

    if (!this.productsLoaded) {
      await this.loadProducts();
      this.productsLoaded = true;
    }

  }

  close() {

    this.modal.hidden = true;

    document.documentElement.classList.remove('complete-the-look-open');

  }

  async loadProducts() {

    this.productsContainer.innerHTML = `
      ${this.renderSkeletons(3)}
    `;

    const recommendations = document.querySelector(
      'product-recommendations'
    );

    if (!recommendations) {
      console.warn('Recommendations element not found.');
      return;
    }

    const url = recommendations.dataset.url;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Failed to fetch recommendations.');
    }

    const html = await response.text();

    const parser = new DOMParser();

    const doc = parser.parseFromString(html, 'text/html');

    const cards = doc.querySelectorAll('.grid__item.grid-product');

    const products = [...cards].filter(card => card.dataset.productId !== this.productId.toString()).map((card) => {
      const image = card.querySelector('img');
      const title = card.querySelector('.grid-product__title');
      const price = card.querySelector('.grid-product__price');
      const button = card.querySelector('.btn-custom-upsell');
      const discountedPrice = Math.round(Number(card.dataset.price) * 0.85);
     console.log(price);
      return {
        productId: card.dataset.productId,
        handle: card.dataset.productHandle,
        title: title?.textContent.trim(),
        price: Number(card.dataset.price),          
        formattedPrice: price?.textContent.trim(),
        discountedPrice,
        image: image?.src,
        variantId: button?.dataset.id,
        swatches: JSON.parse(card.dataset.productSwatches || '[]')
      };
    });

    this.productsContainer.innerHTML = products
      .map((product, index) => `
        <div class="complete-the-look-card"  data-product-index="${index}">
        <a
          class="ctl-link"
          href="/products/${product.handle}">
          <img
            class="ctl-image"
            src="${product.image}"
            alt="${product.title}"
          >
        </a>

        <div class="ctl-content">
          <a
            class="ctl-link"
            href="/products/${product.handle}">

            <h3 class="ctl-title">
              ${product.title}
            </h3>

          </a>
          <div class="ctl-price">
            <span class="ctl-price-original">
              ${product.formattedPrice}
            </span>

            <span class="ctl-price-sale">
              ${this.formatMoney(product.discountedPrice)}
            </span>
            ${
              this.discountNote
                ? `<span class="ctl-price-note">${this.discountNote}</span>`
                : ''
            }
          </div>

         

          <div class="grid-product__colors grid-product__colors-grid">
            ${product.swatches.map(swatch => `
              <button
                type="button"
                class="color-swatch color-swatch-pr-grid color-swatch--small ctl-swatch ${
                  swatch.handle === product.handle ? 'active' : ''
                } ${
                  this.useColorSwatches ? 'native' : ''
                }
                ${
                  this.useColorSwatches ? swatch.colorSwatchHex ? '' : swatch.colorSwatchImage ? 'native-image' : '' : ''
                }
                "
                style="
                    ${
                      this.useColorSwatches
                        ? swatch.colorSwatchHex
                          ? `--swatch-background: linear-gradient(
                              to right,
                              ${swatch.colorSwatchHex},
                              ${swatch.colorSwatchHex}
                            );`
                          : swatch.colorSwatchImage
                            ? `background-image: url(${swatch.colorSwatchImage});
                              background-size: cover;`
                            : `background-image: url(${swatch.swatchImage});
                              background-size: contain;`
                        : `background-image: url(${swatch.swatchImage});
                          background-size: contain;`
                    }
                  "
                data-swatch='${JSON.stringify(swatch)}'>

                <span class="sr-only">${swatch.title}</span>

              </button>
            `).join('')}
          </div>

            <button
              class="complete-the-look-atc ctl-add"
              data-variant-id="${product.variantId}">
              <span class="ctl-add-text">Add to Cart</span>
              <span class="ctl-add-spinner" hidden></span>
            </button>
          </div>
        </div>
      `)
      .join('');

    this.productsContainer
      .querySelectorAll('.complete-the-look-atc')
      .forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();
          this.addToCart(button.dataset.variantId, button);
        });
      });
    
    document
      .querySelectorAll('.ctl-swatch')
      .forEach(button => { 
        button.addEventListener('click', () => {
          const card = button.closest('.complete-the-look-card');
          const swatch = JSON.parse(button.dataset.swatch);
          const discountedPrice = Math.round(swatch.priceCents * 0.85);

          card.querySelector('.ctl-image').src = swatch.image;
          card.querySelector('.ctl-title').textContent = swatch.title;
          card.querySelector('.ctl-price-original').textContent = swatch.price;
          card.querySelector('.ctl-price-sale').textContent = this.formatMoney(discountedPrice);
          card.querySelector('.ctl-add').dataset.variantId = swatch.variantId;
          card.querySelector('.ctl-link').href = swatch.url;

          card.querySelectorAll('.ctl-swatch').forEach(el => el.classList.remove('active'));

          button.classList.add('active');
      });

    });
  }
  async addMainProduct() {
    const cart = await this.getCart();

    const hasMainProduct = cart.items.some(item =>
      item.variant_id === this.mainVariantId
    );

    if (!hasMainProduct) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.mainVariantId,
          quantity: 1
        })
      });
    }
  }
  async addToCart(variantId, button) {
    const text = button.querySelector('.ctl-add-text');
    const spinner = button.querySelector('.ctl-add-spinner');

    button.classList.add('is-loading');
    text.hidden = true;
    spinner.hidden = false;

    // const cart = await this.getCart();
    const items = [];
    // console.log('Main variant:', this.mainVariantId);
    console.log('Accessory variant:', Number(variantId));
    // const hasMainProduct = cart.items.some(item =>
    //   item.variant_id === this.mainVariantId
    // );
    // if (!hasMainProduct) {

    //   items.push({
    //     id: this.mainVariantId,
    //     quantity: 1
    //   });

    // }
    items.push({
      id: Number(variantId),
      quantity: 1
    });
    console.log('Items being added:', items);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({items})
      });

      if (!response.ok) {
        throw new Error('Failed to add product.');
      }
      console.log('Added to cart');
    } catch (error) {
      console.error(error);
    } finally {

      button.classList.remove('is-loading');
      text.hidden = false;
      spinner.hidden = true;

    }
  }
  formatMoney(cents) {
    return `${new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD'
    }).format(cents / 100)} CAD`;
    }
  renderSkeletons(count = 3) {
    return Array.from({ length: count })
      .map(() => `
        <div class="complete-the-look-card complete-the-look-card--skeleton">

          <div class="ctl-skeleton ctl-skeleton-image"></div>

          <div class="ctl-content">

            <div class="ctl-skeleton ctl-skeleton-title"></div>

            <div class="ctl-skeleton ctl-skeleton-price"></div>

            <div class="ctl-skeleton-swatches">
              ${Array.from({ length: 5 })
                .map(() => `<span class="ctl-skeleton ctl-skeleton-swatch"></span>`)
                .join('')}
            </div>

            <div class="ctl-skeleton ctl-skeleton-button"></div>

          </div>

        </div>
      `)
      .join('');
  }

  async getCart() {

    const response = await fetch('/cart.js');

    if (!response.ok) {
      throw new Error('Failed to fetch cart.');
    }

    return response.json();

  }

  async checkComplementaryProducts() {
    const recommendations = document.querySelector('product-recommendations');

    if (!recommendations) return;

    const response = await fetch(recommendations.dataset.url);
    const html = await response.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');

    const cards = doc.querySelectorAll('.grid__item.grid-product');
    console.log('CARDS', cards)

    const products = [...cards].filter(
      card => card.dataset.productId !== this.productId.toString()
    );

    console.log('PRODUCTS', products)

    if (products.length == 0) {
      this.trigger.style.display = 'none';
      return;
    }
    this.trigger.style.display = 'inline-block';
  }

}

document.addEventListener('DOMContentLoaded', () => {

  new CompleteTheLook();

});
